module.exports = __webpack_public_path__ + "img/partner_5.aec96644.png";